import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { extractCommonItemProps } from '../../../../../util/layout/layoutPropsExtractor.js';
import '../../../../../util/styles/index.js';
import '../../../hooks/useEmblaCarousel.js';
import { useLocaleContext, Direction } from '../../../../../contexts/session/Locale.js';
import { useCarouselEventListeners } from './useCarouselEventListeners.js';
import { useCarouselNavigation } from './useCarouselNavigation.js';
import { useCarouselState } from './useCarouselState.js';
import { useCurrentCardEffect } from './useCurrentCardEffect.js';
import { usePageChangeHandler } from './usePageChangeHandler.js';
import { CAROUSEL_CONSTANTS } from '../constants.js';
import useEmblaCarousel from 'embla-carousel-react';
import { useAdsStyles } from '../../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["gap", "pageButtons", "currentCard", "onPageChange", "onBlur", "onFocus", "onMouseEnter", "onMouseLeave", "height"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useRoot = function useRoot(props) {
  var gap = props.gap,
    pageButtons = props.pageButtons,
    currentCard = props.currentCard,
    onPageChange = props.onPageChange,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    height = props.height,
    restProps = _objectWithoutProperties(props, _excluded);
  var commonItemProps = extractCommonItemProps(restProps);
  var _useLocaleContext = useLocaleContext(),
    direction = _useLocaleContext.direction;
  var isRTL = direction === Direction.RTL;
  var eventHandlers = {
    onBlur: onBlur,
    onFocus: onFocus,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };

  // Initialize carousel with Embla
  var _useEmblaCarousel = useEmblaCarousel({
      inViewThreshold: CAROUSEL_CONSTANTS.IN_VIEW_THRESHOLD,
      slidesToScroll: 'auto',
      axis: 'x',
      direction: isRTL ? 'rtl' : 'ltr'
    }),
    _useEmblaCarousel2 = _slicedToArray(_useEmblaCarousel, 2),
    carouselRef = _useEmblaCarousel2[0],
    carouselApi = _useEmblaCarousel2[1];

  // Custom hooks for separated concerns
  var _useCarouselState = useCarouselState(),
    carouselState = _useCarouselState.carouselState,
    updateCarouselState = _useCarouselState.updateCarouselState;
  var handlePageChange = usePageChangeHandler(onPageChange);
  var _useCarouselNavigatio = useCarouselNavigation(carouselApi),
    scrollPrev = _useCarouselNavigatio.scrollPrev,
    scrollNext = _useCarouselNavigatio.scrollNext,
    handleKeyDown = _useCarouselNavigatio.handleKeyDown;

  // Effects
  useCurrentCardEffect(carouselApi, currentCard);
  useCarouselEventListeners(carouselApi, updateCarouselState, handlePageChange);

  // Context value
  var contextValue = {
    carouselRef: carouselRef,
    carouselApi: carouselApi,
    scrollPrev: scrollPrev,
    scrollNext: scrollNext,
    canScrollPrev: carouselState.canScrollPrev,
    canScrollNext: carouselState.canScrollNext,
    gap: gap,
    pageButtons: pageButtons,
    current: carouselState.current,
    pages: carouselState.pages
  };

  // Styles
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var rootStyles = mapAdsStyles(_objectSpread({
    position: 'relative',
    width: '100%',
    height: height
  }, commonItemProps));
  var rootProps = _objectSpread(_objectSpread(_objectSpread({
    onKeyDownCapture: handleKeyDown,
    dir: isRTL ? 'rtl' : 'ltr'
  }, rootStyles), eventHandlers), restProps);
  return {
    contextValue: contextValue,
    rootProps: rootProps
  };
};

export { useRoot };
//# sourceMappingURL=useRoot.js.map
